import { Avatar, Button, Card } from "antd";
import { PencilIcon } from "../../../../atoms/CustomIcons";
import { PopUp } from "../../../../atoms/PopUp";
import MyProfilePopUp from "../MyProfilePopUp";
import { useState } from "react";
import { UserType } from "../../ducks/types";
import { getInitials } from "../../../../config/utils";
import { PhoneInput } from "react-international-phone";

type PropsType = {
  data: UserType | null;
};

export default function MyProfileCard(props: PropsType) {
  const { data } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);

  const myProfilePopup = {
    visibility: isModalOpen,
    class: isCropModalOpen ? "profileModal" : "",
    content: (
      <MyProfilePopUp
        onClose={() => setIsModalOpen(false)}
        setIsCropModalOpen={setIsCropModalOpen}
        data={data}
      />
    ),
    width: 640,
    onCancel: () => setIsModalOpen(false),
  };

  return (
    <Card className="profileData">
      <div className="cardTop">
        {data?.image_url ? (
          <Avatar
            src={`${data?.image_url ?? "/images/myProfile/upload-avatar.png"}`}
            className="avatar"
            size={106}
          />
        ) : data?.first_name && data?.last_name ? (
          <Avatar
            style={{ backgroundColor: "#6454F4", border: 0 }}
            size={106}
            className="profile_avatar"
          >
            {getInitials(data?.first_name, data?.last_name)}
          </Avatar>
        ) : (
          <Avatar
            src="/images/myProfile/upload-avatar.png"
            className="avatar"
            size={106}
          />
        )}

        <div className="cardEdit">
          <Button
            icon={<PencilIcon />}
            onClick={() => setIsModalOpen(true)}
            style={{ border: "unset" }}
          />
        </div>
      </div>
      <div className="cardInfo">
        <h2>{`${data?.first_name ?? ""} ${data?.last_name ?? ""}`}</h2>
        <div className="profileWrapper">
          <div className="profileDetail" style={{ marginBottom: 0 }}>
            <div className="profileLabel">Phone:</div>
            <div className="profileValue">
              {data?.phone ? <PhoneInput disabled value={data?.phone} /> : "-"}
            </div>
          </div>
          <div className="profileDetail">
            <div className="profileLabel">Email:</div>
            <div className="profileValue">{data?.email}</div>
          </div>
        </div>
      </div>

      <PopUp {...myProfilePopup} />
    </Card>
  );
}
